import React from 'react';
import { CustomRoutes } from 'react-admin';
import Onboard from './onboard/onboard';
import Trial from './onboard/resetPassword';
import ForgotPassword from './onboard/forgotPassword'

export default [
    <CustomRoutes exact path="/reset-password" component={Trial}  />,
    // <RouteWithoutLayout exact path="/resetPassword" component={Onboard}  />,
    <CustomRoutes
                    exact
                    path="/forgot-password"
                    component={ForgotPassword}
                />
];